import request from "@/utils/request";

// 获取昨日简报的店铺数据 
export function GetYesterdayBriefing(params) {
  return request({
    url: "/h5/YesterdayBriefing/index",
    method: "post",
    params,
  });
}
// 获取昨日简报的多店铺切换名称
export function GetYesterdayShops(params) {
  return request({
    url: "/h5/YesterdayBriefing/getBossShopList",
    method: "post",
    params,
  });
}
// 昨日客户/客户类型
export function YesterdayCustomer(params) {
  return request({
    url: "/h5/YesterdayCustomer/index",
    method: "post",
    params,
  });
}
